export const IconGrayArrowsVerticalDropdown: {
  name: 'icon_gray_arrows_vertical_dropdown-1ce20616c3da'
} = {
  name: 'icon_gray_arrows_vertical_dropdown-1ce20616c3da'
}
